module.exports = __webpack_public_path__ + "1d22953c479914c2f801e08de666b0e8.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/clarity-ui/dist/fonts/open-sans-light-italic.ttf
// module id = 1569
// module chunks = 0